import * as React from "react"
import { SelectSeeker } from "@ui-seeker/core"

import {useSignal} from "@preact/signals-react";


const OPTIONS = [
    { label: 'Sunday', value: 0 },
    { label: 'Monday', value: 1 },
    { label: 'Tuesday', value: 2 },
    { label: 'Wednesday', value: 3 },
    { label: 'Thursday', value: 4 },
    { label: 'Friday', value: 5 },
    { label: 'Saturday', value: 6 }
]

export default function WeekDaysSelect({ ...props }) {
    const dayValue = useSignal([])
    return <SelectSeeker
        options={OPTIONS}
        label="Select Week Day (Leave Empty Means Everyday)"
        value={dayValue.value}
        onChange={e => dayValue.value = e.target.value}
        isClearable
        {...props}
    />
}